import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import {wasAskedTutorialSelector, handleSetAppData} from "./app"
import {currentSubjectSelector, subjectsWithTrashedSelector} from './subjects'
import {CONFIRM, CONFIRM_TYPE_PRIMARY, showModal, hideModal, QBM_CRUD} from "./modals"
import {push} from 'react-router-redux'
import {pathnameSelector} from './router'
import {routesUrls} from '../settings/routes'
import {arrayToMap} from '../helpers/common'
import {handleSubjectClick, firstOrderedSubjectSelector} from './subjects'
import {setQbmNavItem, QBM_NAV_SUBJECTS} from './app'
import {categoriesTreeMapSelector, setCategoryCheckedState} from './categories'
import {checkAndUploadQuestions} from './questions'


/**
 * Constants
 * */

export const moduleName = 'tutorial'
const prefix = `${appName}/${moduleName}`

const SET_TUTORIAL_MODE = `${prefix}/SET_TUTORIAL_MODE`
const SET_CURRENT_TUTORIAL_STEP = `${prefix}/SET_CURRENT_TUTORIAL_STEP`
const SET_TUTORIAL_STEP = `${prefix}/SET_TUTORIAL_STEP`

const STOP_TUTORIAL = `${prefix}/STOP_TUTORIAL`


export const CLICK_CREATE_SUBJECT_STEP = 1
export const CREATE_SUBJECT_MODAL_STEP = 2
export const SELECT_SUBJECT_STEP = 3
export const CLICK_CREATE_CATEGORY_STEP = 4
export const CREATE_CATEGORY_MODAL_STEP = 5
export const CLICK_MULTIPLE_CHOICE = 6

export const tooltipGeneralProps = {
}

const step1ParentId = "for-tooltip-step-1"
const step3ParentId = "for-tooltip-step-3"
const step4ParentId = "for-tooltip-step-4"
const step6ParentId = "for-tooltip-step-6"

export const stepsData = {
    [CLICK_CREATE_SUBJECT_STEP] : {
        step : CLICK_CREATE_SUBJECT_STEP,
        text : "We designed classification of questions depending on subjects. Click '+' button and create subject!",
        pathname : routesUrls.questions,
        cancelBtnTxt : "Stop tour",
        okBtnTxt : "Next",
        cancelBtnClassName : "btn-warging",
        parentProps : {
            id : step1ParentId,
        },
        tooltipProps : {
            id : "tooltip-step-1",
            placement : "right",
        },
    },
    [SELECT_SUBJECT_STEP] : {
        step : SELECT_SUBJECT_STEP,
        text : "In order to continue select desired subject...",
        pathname : routesUrls.questions,
        cancelBtnTxt : "Stop tour",
        okBtnTxt : "Next",
        cancelBtnClassName : "btn-warging",
        parentProps : {
            id : step3ParentId,
        },
        tooltipProps : {
            id : "tooltip-step-3",
            placement : "right",
        },
    },
    [CLICK_CREATE_CATEGORY_STEP] : {
        step : CLICK_CREATE_CATEGORY_STEP,
        text : "and create categories inside.",
        pathname : routesUrls.questions,
        cancelBtnTxt : "Stop tour",
        okBtnTxt : "Next",
        cancelBtnClassName : "btn-warging",
        parentProps : {
            id : step4ParentId,
        },
        tooltipProps : {
            id : "tooltip-step-4",
            placement : "right",
        },
    },
    [CLICK_MULTIPLE_CHOICE] : {
        step : CLICK_MULTIPLE_CHOICE,
        text : "Click '+ Multiple Choice' Button in order to add your first question. Type question text, add minimum 4 distractors and specify correct answer! Enjoy!",
        pathname : routesUrls.questions,
        cancelBtnTxt : "Thanks!",
        cancelBtnClassName : "btn-info",
        parentProps : {
            id : step6ParentId,
        },
        tooltipProps : {
            id : "tooltip-step-6",
            placement : "bottom",
        },
    }
}



/**
 * Reducer
 * */

const defaultTutorialStep = CLICK_CREATE_SUBJECT_STEP

const stepRecord = Record({
    step : null,
    container : null,
    target : null
})

export const ReducerRecord = Record({
    tutorialMode : false,
    currentStep : defaultTutorialStep,
    steps : arrayToMap([], stepRecord, 'step'),
})

const defaultState = new ReducerRecord()

export default function reducer(state = defaultState, action) {
    const {type, payload} = action

    switch (type) {
        case SET_TUTORIAL_MODE : {
            let {isOn = false} = payload
            return state.set('tutorialMode', isOn)
            break
        }
        case SET_CURRENT_TUTORIAL_STEP : {
            let {currentStep} = payload
            return state.set('currentStep', currentStep)
            break
        }
        case SET_TUTORIAL_STEP : {
            let {step, target, container} = payload
            state = state.updateIn(['steps', step], s => s ? s : new stepRecord({step}))
            if (typeof target !== 'undefined') state = state.updateIn(['steps', step], s => s.set('target', target))
            if (typeof container !== 'undefined') state = state.updateIn(['steps', step], s => s.set('container', container))
            return state
            break
        }
        case STOP_TUTORIAL : {
            return state.set('tutorialMode', false).set('currentStep', defaultTutorialStep)
            break
        }
        default : {
            return state
            break
        }
    }
}

/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]

export const tutorialModeSelector = createSelector(stateSelector, state => state.tutorialMode)
export const tutorialCurrentStepSelector = createSelector(stateSelector, state => state.currentStep)
export const tutorialStepsMapSelector = createSelector(stateSelector, state => state.steps)


const _getStepNum = (_, stepNum) => stepNum

export const tutorialStepSelector = createSelector(tutorialStepsMapSelector, _getStepNum, (tutorialMap, stepNum) => {
    return tutorialMap.get(stepNum)
})

export const tutorialStepIsOnSelector = createSelector(tutorialModeSelector, tutorialCurrentStepSelector, pathnameSelector, tutorialStepSelector, _getStepNum, (tutorialIsOn, currentStep, pathname, tutorialStep, stepNum) => {
    const isOn =
        tutorialIsOn &&
        currentStep === stepNum &&
        pathname === stepsData[stepNum].pathname &&
        tutorialStep &&
        tutorialStep.target &&
        tutorialStep.container &&
        true

    return isOn
})



/**
 * Action Creators
 * */

export const setTutorialMode = isOn => ({
    type : SET_TUTORIAL_MODE,
    payload : {
        isOn
    }
})

export const setCurrentTutorialStep = currentStep => ({
    type : SET_CURRENT_TUTORIAL_STEP,
    payload : {
        currentStep
    }
})

export const setTutorialStep = params => {
    let {step, target, container} = params
    return {
        type : SET_TUTORIAL_STEP,
        payload : {
            step,
            target,
            container,
        }
    }
}

export const stopTutorial = () => ({
    type : STOP_TUTORIAL
})


/**
 * Thunk
 * */

export const handleSetTutorialStep = params => (dispatch, getState) => {
    const {target, container} = params
    if (!target || !container) {
        dispatch(setTutorialStep(params))
        return
    }

    const state = getState()
    const tutorialStep = tutorialStepSelector(state)
    if (!tutorialStep) {
        dispatch(setTutorialStep(params))
        return
    }

    const {target : currentTarget, container : currentContainer} = tutorialStep
    if (currentTarget && currentContainer) return

    dispatch(setTutorialStep(params))
}

export const handleTutorialStart = () => (dispatch, getState) => {
    const state = getState()
    const wasAskedTutorial = wasAskedTutorialSelector(state)
    const subjectsWithTrashed = subjectsWithTrashedSelector(state)
    const tutorialIsOn = tutorialModeSelector(state)

    if (tutorialIsOn) return

    if (wasAskedTutorial) return

    if (subjectsWithTrashed.length) return

    let finalCb = () => {
        dispatch(hideModal({modalType : CONFIRM}))

        dispatch(handleSetAppData({wasAskedTutorial : true}))
    }

    dispatch(showModal({
        modalType : CONFIRM,
        modalProps : {
            title : "Welcome",
            confirmText : `We noticed you have not visited Question Bank Manager before, would you like to take a brief tour? You can also start it later from "Profile" page.`,
            okButtonTxt : "Take a tour",
            cancelButtonTxt : "No, thanks",
            infoType : CONFIRM_TYPE_PRIMARY,
            okCb : () => {
                dispatch(handleStep_clickCreateSubjectStep())
                finalCb()
            },
            cancelCb : finalCb
        }
    }))
}

export const handleStep_clickCreateSubjectStep = () => dispatch => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(CLICK_CREATE_SUBJECT_STEP))
    goToTutorialPage(dispatch)
    dispatch(setQbmNavItem(QBM_NAV_SUBJECTS))
}

export const handleStep_createSubjectModalStep = () => dispatch => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(CREATE_SUBJECT_MODAL_STEP))
    goToTutorialPage(dispatch)
    dispatch(showModal({
        modalType : QBM_CRUD,
        modalProps : {
            qbmEntity : "subject",
            qbmCrudAction : "create"
        }
    }))
}

export const handleStep_selectSubjectStep = () => dispatch => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(SELECT_SUBJECT_STEP))
    goToTutorialPage(dispatch)
}

export const handleStep_clickCreateCategoryStep = (withSubjectClick) => (dispatch, getState) => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(CLICK_CREATE_CATEGORY_STEP))
    goToTutorialPage(dispatch)
    if (withSubjectClick) {
        const state = getState()
        let firstOrderedSubject = firstOrderedSubjectSelector(state)
        if (firstOrderedSubject) dispatch(handleSubjectClick(firstOrderedSubject.id))
    }
}

export const handleStep_createCategoryModalStep = () => dispatch => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(CREATE_CATEGORY_MODAL_STEP))
    goToTutorialPage(dispatch)

    dispatch(showModal({
        modalType : QBM_CRUD,
        modalProps : {
            qbmEntity : "category",
            qbmCrudAction : "create"
        }
    }))
}

export const handleStep_clickMultipleChoice = () => (dispatch, getState) => {
    dispatch(setTutorialMode(true))
    dispatch(setCurrentTutorialStep(CLICK_MULTIPLE_CHOICE))
    goToTutorialPage(dispatch)

    const state = getState()
    const currentSubject = currentSubjectSelector(state)
    if (currentSubject) {
        const categoriesIds = currentSubject.categoriesIds.keySeq().toArray()
        let categoriesTree = Object.values(categoriesTreeMapSelector(state, categoriesIds))
        let firstCategory = categoriesTree[0]
        if (firstCategory) {
            dispatch(setCategoryCheckedState({id : firstCategory.id, isChecked : true}))
            checkAndUploadQuestions()
        }
    }
}

/*
* helpers
* */

const goToTutorialPage = dispatch => dispatch(push(routesUrls.questions))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/tutorial.js